export enum LayoutType {
  SINGLE = 'single',
  SPLIT = 'split',
  SPLIT_EXTEND = 'split-extend',
}

export enum LayoutMinHeight {
  MID = 'mid',
  FULL = 'full',
}
